import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/goods/preview_sku_bg_d2c.png'
import _imports_1 from '@/assets/image/goods/preview_sku_bg_b2b.png'
import _imports_2 from '@/assets/image/error_img.png'
import _imports_3 from '@/assets/image/goods/copy.png'


const _withScopeId = n => (_pushScopeId("data-v-1547aa97"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "goods-preview-sku" }
const _hoisted_2 = {
  key: 0,
  src: _imports_0,
  alt: "",
  class: "preview-bg",
  draggable: "false"
}
const _hoisted_3 = {
  key: 1,
  src: _imports_1,
  alt: "",
  class: "preview-bg",
  draggable: "false"
}
const _hoisted_4 = { class: "goods-preview-sku-title" }
const _hoisted_5 = { class: "flexcenter" }
const _hoisted_6 = { style: {"width":"360px","height":"360px","margin":"12px 8px"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "image-slot" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1))
const _hoisted_8 = { class: "copy-btn" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "sku-text" }
const _hoisted_11 = { class: "preview-sku-tool" }
const _hoisted_12 = { class: "sku-name" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-guige_zhankai" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-guige_zhankai",
  style: {"transform":"rotate(-180deg)"}
}, null, -1))

import { t } from '@/plugins/i18n'
import { ref, watch } from 'vue'
import { isD2C, isJA } from '@/store'
import { ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  props: ['product', 'sku'],
  emits: ['updateNum'],
  setup(__props, { emit }) {

const props = __props


const isOpen = ref(false) // 是否收起
const skuList: any = ref([])
const height = ref(0)
const skuNormalList: any = ref([])
watch(() => props.sku, (newValue, oldValue) => {
  const sku = Object.keys(newValue).map((key) => {
    return newValue[key].productSku
  })
  if (sku.length > skuList.value.length) {
    const checkSku = sku.filter((temp: any) => { return skuList.value.indexOf(temp) === -1 })
    skuNormalList.value.forEach((item: any, index: any) => {
      if (checkSku.indexOf(item.productSku) > -1) {
        skuNormalList.value.unshift(skuNormalList.value.splice(index, 1)[0])
      }
    })
  }
  skuList.value = sku
}, {
  immediate: true,
  deep: true
})
watch(() => props.product, (newValue) => {
  skuNormalList.value = newValue.skuList
  const ele: any = document.querySelector('.goods-summary')
  if (ele && ele.offsetHeight) {
    height.value = (ele.offsetHeight - 80) > (document.documentElement.offsetHeight - 250) ? document.documentElement.offsetHeight - 250 : (ele.offsetHeight - 80)
  }
}, {
  immediate: true,
  deep: true
})
const copy = (text: string) => {
  const aux = document.createElement('input')
  aux.setAttribute('value', text)
  document.body.appendChild(aux)
  aux.select()
  document.execCommand('copy')
  document.body.removeChild(aux)
  ElMessage.success(t('复制成功'))
}

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _directive_drag = _resolveDirective("drag")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isD2C)())
      ? (_openBlock(), _createElementBlock("img", _hoisted_2))
      : (_openBlock(), _createElementBlock("img", _hoisted_3)),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('平台商品SKU')), 1),
    _createElementVNode("div", {
      class: _normalizeClass([{ open: isOpen.value }, 'sku-list']),
      style: _normalizeStyle({ height: isOpen.value && __props.product.skuList && (height.value + 'px') || '100px' })
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(skuNormalList.value, (item, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (isOpen.value || !isOpen.value && index === 0)
            ? (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass([{ active: skuList.value.includes(item.productSku) }, 'sku-item']),
                key: index
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_el_tooltip, {
                    placement: "left",
                    effect: "light"
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_el_image, {
                          src: item.productSkuImg || __props.product.productMainImg
                        }, null, 8, ["src"])
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_image, {
                        src: item.productSkuImg || __props.product.productMainImg,
                        class: "sku-img"
                      }, {
                        error: _withCtx(() => [
                          _hoisted_7
                        ]),
                        _: 2
                      }, 1032, ["src"])
                    ]),
                    _: 2
                  }, 1024),
                  _createElementVNode("span", {
                    class: "sku",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(() => { }, ["stop"]))
                  }, "sku " + _toDisplayString(item.productSku), 1),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("img", {
                      src: _imports_3,
                      alt: "",
                      onClick: ($event: any) => (copy(item.productSku))
                    }, null, 8, _hoisted_9)
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_el_tooltip, {
                    "popper-class": "preview-sku-tool-component",
                    effect: "light",
                    placement: "top"
                  }, {
                    content: _withCtx(() => [
                      _createElementVNode("div", _hoisted_11, _toDisplayString((_unref(isJA)() && item.productPropertiesNameJa ? item.productPropertiesNameJa :
                    item.productPropertiesName).replace(/[+-]?\d+:[+-]?\d+:/ig, '')), 1)
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_12, _toDisplayString((_unref(isJA)() && item.productPropertiesNameJa ? item.productPropertiesNameJa :
                item.productPropertiesName).replace(/[+-]?\d+:[+-]?\d+:/ig, '')), 1)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ], 2))
            : _createCommentVNode("", true)
        ], 64))
      }), 256))
    ], 6),
    _createElementVNode("div", {
      class: "sku-action",
      onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (isOpen.value = !isOpen.value), ["stop"]))
    }, [
      (!isOpen.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('详情')), 1),
            _hoisted_13
          ], 64))
        : _createCommentVNode("", true),
      (isOpen.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('关闭2')), 1),
            _hoisted_14
          ], 64))
        : _createCommentVNode("", true)
    ])
  ], 512)), [
    [_directive_drag]
  ])
}
}

})